import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation-triangle",
  "use": "exclamation-triangle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"exclamation-triangle\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.267 2.003c.77-1.335 2.696-1.335 3.465 0l4.903 8.498c.77 1.333-.193 3-1.732 3H3.097c-1.54 0-2.502-1.667-1.732-3l4.902-8.498ZM8 5.5a.5.5 0 0 1 .5.5v2.5a.5.5 0 1 1-1 0V6a.5.5 0 0 1 .5-.5ZM8 11a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol